<template>
  <TWModal
    :title="$t('sharing.sharing')"
    :show="isOpen"
    :auto-focus="false"
    :loading="isLoading || isSharingLoading"
    @close="close">
    <template v-slot:content>
      <SharingView
        @itemAdded="itemAdded"
        @itemRemoved="itemRemoved"
        @permissionChanged="permissionChanged"
        @isLoading="updateSharingLoading"
        :permittedActorsListTitle="$t('sharing.currentSharing', {resource:'template'})"
        :resource="template"
        v-model="sharingSettings"
      />
    </template>
    <template v-slot:controls>
      <button
        type="button"
        class="tw-button mr-2"
        data-test="cancel-button"
        data-ec="template_sharing_modal"
        data-et="btn_cancel"
        @click="close">
        <span>{{ $t('functional.cancel') }}</span>
      </button>
      <button
        type="button"
        id="save-template-share-modal-button"
        class="tw-button tw-button-cta"
        data-test="confirm-button"
        data-ec="template_sharing_modal"
        data-et="btn_save"
        @click="save">
        <span>{{ $t('functional.confirm') }}</span>
      </button>
    </template>
  </TWModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { logAmplitudeEvent } from '@/utils/analytics';
import SharingView from '@/components/Sharing.vue';
import TWModal from '@/components/tailwind/Modal.vue';

export default {
  name: 'TemplateSharingModal',
  components: {
    SharingView,
    TWModal,
  },
  props: {
    template: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      isLoading: false,
      isSharingLoading: false,
      sharingSettings: {},
    };
  },
  computed: {
    ...mapGetters({
      editorPermission: 'permissions/editor',
      authenticatedUser: 'user/user',
    }),
    initialSharingSettings() {
      return { ...this.template.sharing, everyone_permission: this.template.everyone_permission };
    },
  },
  methods: {
    ...mapActions({
      updateSharingSettings: 'template/UPDATE_SHARING',
    }),
    async open() {
      this.sharingSettings = this.initialSharingSettings;
      this.$bus.$emit('closeModal'); // Close other (legacy) modals
      this.isOpen = true;
      this.$emit('opened');
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    close($event) {
      if ($event && $event.target.classList.contains('multiselect__input')) {
        document.getElementById('save-template-share-modal-button').focus();
        return;
      }

      this.$emit('closed');
      this.resetData();
    },
    updateSharingLoading(loading) {
      this.isSharingLoading = loading;
    },
    itemAdded(item) {
      logAmplitudeEvent('template_sharing_modal--added_actor_to_template_sharing', { type: item.type });
    },
    itemRemoved(item) {
      logAmplitudeEvent('template_sharing_modal--removed_actor_from_template_sharing', { type: item.type });
    },
    permissionChanged(value) {
      logAmplitudeEvent('template_sharing_modal--permission_changed', { type: value.slug });
    },
    async save() {
      this.isLoading = true;

      try {
        await this.updateSharingSettings({
          id: this.template.fingerprint,
          sharing: this.sharingSettings,
        });
        this.$bus.$emit('renderGlobalMessage', ({
          message: this.$t('sharing.updateSuccess'),
          icon: 'check',
          type: 'success',
        }));
        this.close();
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        this.$bus.$emit('renderGlobalMessage', ({
          message: this.$t('sharring.updateFailed'),
          icon: 'times',
          type: 'error',
        }));
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
